import type { MetricsDistributionResponse } from "../../../../../shared/api/types";

export interface ProgressBarData {
  label: string;
  value: number;
}

export const transformProgrammeGoals = (
  data: MetricsDistributionResponse | undefined
): ProgressBarData[] => {
  if (!data?.data?.distribution || data.data.distribution.length === 0)
    return [];

  // Goals are multi-select: use the normalised percentage (share of all
  // selections, sums to 100%), not the raw count — the chart renders this
  // value with a "%" suffix.
  return data.data.distribution
    .map((item) => ({
      label: (item.label || item.name || "Unknown")
        .split("-")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" "),
      value: item.percentage,
    }))
    .sort((a, b) => b.value - a.value);
};
